import { Box } from "@mui/material";
import { DataGrid, GridColDef, itIT } from "@mui/x-data-grid";
import { ReactComponent as ModifyIcon } from "../../../../assets/icons/MedintModifyIcon.svg";
import { formattedAnapreDataObject } from "../../../../services/medintInterfaces";
import { useEffect, useState } from "react";

const columns: GridColDef[] = [
  { field: "id", editable: false, flex: 1 },
  { field: "idAnapre", editable: false, flex: 1 },
  {
    field: "Data Inserimento",
    headerName: "Data Inserimento",
    editable: false,
    flex: 2,
  },
  { field: "codice", headerName: "Codice", editable: false, flex: 1 },
  { field: "prestazione", headerName: "Prestazione", editable: false, flex: 3 },
  {
    field: "durata",
    headerName: "Durata",
    type: "number",
    headerAlign: "left",
    editable: true,
    flex: 2,
    renderCell: (params) => {
      return (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {`${params.value > 60 ? "60" : params.value} min`}
          <ModifyIcon color="#003267" />
        </Box>
      );
    },
  },
];

const MedintDataGrid = (props: {
  data: formattedAnapreDataObject[];
  selectedRows: any[];
  setSelectedRows: (value: any) => void;
}) => {
  const [selectionModel, setSelectionModel] = useState<number[]>([]);

  useEffect(() => {
    const selectedRows = props.data.filter((row: any) =>
      selectionModel.includes(row.id)
    );

    props.setSelectedRows(selectedRows);

  }, [selectionModel]);

  const handleDurataChange = (rowData: { id: any; durata: any }) => {
    props.data?.map((e: any) =>
      e.id === rowData.id ? (e.durata = rowData.durata) : ""
    );
  };

  return (
    <Box
      sx={{
        height: "30vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <DataGrid
        sx={{
          display: "flex",
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#003267",
            color: "#FFFFFF",
          },
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#F8F9FC",
          },
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: "#FFFFFF",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
          },
          "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
            color: "#FFFFFF",
            "&.Mui-checked": {
              color: "#FFFFFF",
            },
          },
          "& .MuiDataGrid-iconButtonContainer": {
            color: "#FFFFFF",
          },
          "& .MuiDataGrid-sortIcon": {
            color: "#FFFFFF",
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .MuiDataGrid-footerContainer": {
            display: props.data.length < 100 ? "none" : "",
            backgroundColor: "#003267",
            "& .MuiInputBase-root": {
              color: "#FFFFFF",
              fontWeight: "bold",
              "& .MuiSvgIcon-root": {
                color: "#FFFFFF",
              },
            },
            "& .MuiTablePagination-selectLabel": {
              color: "#FFFFFF",
              fontWeight: "bold",
            },
            "& .MuiTablePagination-displayedRows ": {
              color: "#FFFFFF",
              fontWeight: "bold",
            },
            "& .MuiTablePagination-actions .MuiIconButton-root": {
              color: "#FFFFFF",
            },
          },
          "& .MuiDataGrid-cell--editing": {
            border: "2px solid #003267",
          },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
            {
              outline: "none",
            },
          "& .cell-duration:hover": {
            cursor: "pointer",
            backgroundColor: "#DFEAFF",
            border: "1px solid #003267",
          },
        }}
        rows={props.data}
        columns={columns}
        headerHeight={36}
        rowHeight={36}
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
        initialState={{
          columns: {
            columnVisibilityModel: {
              id: false,
              "Data Inserimento": false,
              idAnapre: false,
            },
          },
        }}
        hideFooter
        checkboxSelection
        disableColumnFilter
        disableColumnMenu
        disableSelectionOnClick
        pagination
        rowsPerPageOptions={[25, 50, 100]}
        getCellClassName={(params) => {
          return params.field === "durata" ? "cell-duration" : "";
        }}
        onSelectionModelChange={(newSelection) => {
          setSelectionModel(newSelection as number[]);
        }}
        onCellEditCommit={(params) => {
          if (params.field === "durata") {
            console.log(`Durata modificata per ID ${params.id}:`, params.value);
            handleDurataChange({ id: params.id, durata: params.value });
          }
        }}
      />
    </Box>
  );
};

export default MedintDataGrid;
